module.exports = __webpack_public_path__ + "img/ic_fax.9e886ec9.svg";